<template>
  <layout :title="title" :loading="isLoading">
    <template v-slot:title>
      <div
        class="d-flex align-center justify-space-between"
        style="width: 100%"
      >
        <div class="mr-2">{{ title }}</div>
        <delete-client
          @onUpdate="() => $router.replace({ name: 'clients' })"
          v-if="hasDelete('customers')"
          :item="{
            id: $route.params.id,
          }"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              v-bind="$attrs"
              height="40px"
              depressed
              class="error"
              v-on="on"
            >
              Delete Client
            </v-btn>
          </template>
        </delete-client>
      </div>
    </template>
    <form-wrapper @submit="submit()">
      <v-row class="form-row mt-1">
        <v-col cols="12" md="4">
          <input-field
            label="First Name"
            rules="required"
            v-model="form.first_name"
          />
        </v-col>
        <v-col cols="12" md="4">
          <input-field
            label="Middle Name"
            rules=""
            v-model="form.middle_name"
          />
        </v-col>
        <v-col cols="12" md="4">
          <input-field
            label="Last Name"
            rules="required"
            v-model="form.last_name"
          />
        </v-col>
        <v-col cols="12" md="4">
          <input-field
            label="Preferred Name"
            rules=""
            v-model="form.preferred_name"
          />
        </v-col>
        <v-col cols="12" md="4">
          <input-field
            label="Suffix ( Jr ,  Sr , etc. )"
            rules=""
            v-model="form.suffix"
          />
        </v-col>
        <v-col cols="12" md="4">
          <phone-field label="Phone (M)" rules="phone" name="phone" v-model="form.mobile" />
        </v-col>
        <v-col cols="12" md="4">
          <input-field
            label="Email"
            rules="required|email"
            name="email"
            v-model="form.email"
          />
        </v-col>
        <v-col cols="12" md="4">
          <input-field
            maska="###-##-####"
            label="SSN"
            v-model="form.ss_number"
          />
        </v-col>
        <v-col cols="12" md="4">
          <date-field
            label="Date of Birth"
            rules=""
            v-model="form.birth_date"
          />
        </v-col>
        <v-col cols="12" md="4">
          <address-field
            label="Mailing Address"
            rules="required"
            @onAddress="onAddress"
            v-model="form.street"
          ></address-field>
        </v-col>
        <v-col cols="12" md="4">
          <input-field label="City" rules="" v-model="form.city" />
        </v-col>
        <v-col cols="12" md="4" class="d-flex">
          <autocomplete
            :items="states"
            label="State"
            class="mr-2"
            rules=""
            v-model="form.state"
          />
          <input-field
            label="Zip Code"
            class="ml-2"
            rules="zip"
            v-model="form.postal_code"
          />
        </v-col>
        <template v-if="isShowMore">
          <v-col cols="12" md="4">
            <phone-field
              label="Phone (Alternate)"
              rules="phone"
              v-model="form.home_phone"
            />
          </v-col>
          <v-col cols="12" md="4">
            <phone-field
              label="Phone (Work)"
              rules="phone"
              v-model="form.work_phone"
            />
          </v-col>
          <v-col cols="12" md="4">
            <phone-field label="Fax" rules="phone" v-model="form.fax" />
          </v-col>
        </template>
      </v-row>
      <a @click="isShowMore = !isShowMore">{{
        isShowMore ? "Show Less" : "Show More"
      }}</a>
      <!--Affiliate Don't have access to update the below details -->
      <template v-if="!isAffiliateAuth">
        <v-divider class="mt-4"></v-divider>
        <v-row class="form-row mt-4">
          <v-col cols="12" md="4">
            <client-status-field
              label="Status"
              rules="required"
              v-model="form.customer_type"
            />
          </v-col>
          <v-col cols="12" md="4">
            <select-field
              label="Client Type"
              :items="clientTypes"
              v-model="form.client_type"
            />
          </v-col>
          <v-col cols="12" md="4">
            <div>
              <label class="body-small">Referred By</label>
              <v-combobox
                class="mt-1"
                :items="referrers"
                item-text="name"
                item-value="value"
                clearable
                outlined
                dense
                append-icon="mdi-chevron-down"
                v-model="selectedReferrer"
              />
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              label="Affiliate 1"
              clearable
              :items="affiliates"
              @input="onAffiliateChange('affiliate_id')"
              v-model="form.affiliate_id"
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              label="Affiliate 2 (optional)"
              :items="affiliates"
              v-if="form.affiliate_id"
              v-model="form.affiliate_id_2"
              @input="onAffiliateChange('affiliate_id_2')"
              clearable
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              label="Affiliate 3 (optional)"
              :items="affiliates"
              @input="onAffiliateChange('affiliate_id_3')"
              v-if="form.affiliate_id && form.affiliate_id_2"
              v-model="form.affiliate_id_3"
              clearable
            />
          </v-col>
        </v-row>
      </template>
      <div class="d-flex">
        <v-spacer></v-spacer>
        <close-button :disabled="loading" @click="back()">Cancel</close-button>
        <secondary-button class="ml-3" :loading="loading" type="submit"
          >Submit
        </secondary-button>
      </div>
    </form-wrapper>
  </layout>
</template>

<script>
import Layout from "@/components/ui/Layout.vue";
import InputField from "@/components/ui/form/InputField.vue";
import PhoneField from "@/components/ui/form/PhoneField.vue";
import SelectField from "@/components/ui/form/SelectField.vue";
import ClientStatusField from "@/components/clients/ClientStatusField.vue";
import DateField from "@/components/ui/form/DateField.vue";
import AddressField from "@/components/ui/form/AddressField.vue";
import Autocomplete from "@/components/ui/form/Autocomplete.vue";
import states from "@/assets/constants/states.names";
import FormWrapper from "@/components/ui/form/FormWrapper.vue";
import CloseButton from "@/components/ui/buttons/CloseButton.vue";
import SecondaryButton from "@/components/ui/buttons/SecondaryButton.vue";
import {capitalizeText, getDate, initForm} from "@/assets/utils/common.utils";
import {addDoc, doc, getDoc, getDocs, limit, query, updateDoc, where,} from "firebase/firestore";
import {colClients, colReferrals, functions} from "@/assets/utils/firebase.utils";
import {toTerms} from "@/assets/utils/v2.utils";
import {httpsCallable} from "firebase/functions";
import DeleteClient from "@/components/clients/DeleteClient.vue";

export default {
  components: {
    DeleteClient,
    Layout,
    InputField,
    PhoneField,
    SelectField,
    ClientStatusField,
    DateField,
    AddressField,
    Autocomplete,
    FormWrapper,
    CloseButton,
    SecondaryButton,
  },
  data() {
    return {
      states,
      loading: false,
      isLoading: false,
      isShowMore: false,
      referrers: [],
      selectedReferrer: null,
      originalReferralId: "",
      form: {
        no_email: false,
        first_name: "",
        middle_name: "",
        last_name: "",
        preferred_name: "",
        suffix: "",
        mobile: "",
        email: "",
        ss_number: "",
        birth_date: "",
        street: "",
        city: "",
        state: "",
        postal_code: "",
        home_phone: "",
        work_phone: "",
        fax: "",
        customer_type: "client",
        affiliate_id: "",
        affiliate_id_2: "",
        affiliate_id_3: "",
        client_type: "",
        referred_by: "",
        referral_id: "",
      },
    };
  },
  watch: {
    "form.referral_id"(val) {
      if (val && this.referrers.length && !this.selectedReferrer) {
        this.selectedReferrer =
          this.referrers.find((r) => r.value === val) || null;
      }
    },
    referrers(val) {
      if (this.form.referral_id && val.length && !this.selectedReferrer) {
        this.selectedReferrer =
          val.find((r) => r.value === this.form.referral_id) || null;
      }
    },
  },
  computed: {
    isUpdate() {
      return this.$route.name === "update-client";
    },
    title() {
      return this.isUpdate ? "Edit Profile" : "Add Lead/Client";
    },
  },
  methods: {
    onAffiliateChange(key) {
      const vm = this;
      if (!vm.form[key]) {
        if (key === "affiliate_id") {
          vm.form.affiliate_id_2 = "";
          vm.form.affiliate_id_3 = "";
        }
        if (key === "affiliate_id_2") {
          vm.form.affiliate_id_3 = "";
        }
      }
    },
    back() {
      if (this.isUpdate) {
        let id = this.$route.params.id;
        this.$router.replace({ name: "client-profile", params: { id } });
      } else {
        this.$router.replace({ name: "clients" });
      }
    },
    onAddress(evt) {
      setTimeout(() => {
        let address = `${evt.street_number || ""} ${evt.route || ""}`;
        this.form.street = address.replace(/\s+/g, " ").trim();
      }, 500);
      this.form.postal_code = evt.postal_code || "";
      let state = this.states.find(
        (i) => i.value === evt.administrative_area_level_1
      );
      this.form.city = evt.locality || "";
      if (state) this.form.state = evt.administrative_area_level_1 || "";
    },
    async init() {
      const vm = this;
      if (!vm.isUpdate) return;
      try {
        vm.isLoading = true;
        let clientId = this.$route.params.id;
        let client = (await getDoc(doc(colClients, clientId))).data();
        if (client == null) {
          vm.notifyError("Client not found");
          await vm.$router.replace({ name: "clients" });
          return;
        }
        initForm(vm.form, client);
        vm.originalReferralId = vm.form.referral_id || "";
        if (vm.form.ss_number && vm.form.ss_number.toString().length === 4) {
          vm.form.ss_number = `000-00-${vm.form.ss_number}`;
        }
        if (vm.form.birth_date === "Invalid date") {
          vm.form.birth_date = "";
        }
        vm.isLoading = false;
      } catch (error) {
        vm.handleError(error.message);
      }
    },
    async getClientCountForReferral(referralId) {
      const q = query(colClients, where("referral_id", "==", referralId), limit(2));
      const snap = await getDocs(q);
      return snap.docs.length;
    },
    async submit() {
      const vm = this;
      try {
        await new Promise((resolve) => setTimeout(resolve, 500));
        vm.loading = true;
        let clientId = this.$route.params.id;
        let email = vm.form.email.trim().toLowerCase();
        let name = `${vm.form.first_name} ${vm.form.last_name}`;
        let terms = [name, vm.form.email];
        if (vm.form.mobile) terms.push(vm.form.mobile);
        if (vm.form.home_phone) terms.push(vm.form.home_phone);
        if (vm.form.work_phone) terms.push(vm.form.work_phone);

        // If a referral has only one client:
        // - renaming the referrer on the client updates the referral's name
        // - removing or switching the referrer deletes the referral
        const manageReferral = httpsCallable(functions, "manageReferral");
        let skipReferrerProcessing = false;
        const oldReferralId = vm.originalReferralId;
        const hasOldReferral = oldReferralId && vm.isUpdate;

        if (hasOldReferral) {
          const isSameReferrer =
            typeof vm.selectedReferrer === "object" &&
            vm.selectedReferrer &&
            vm.selectedReferrer.value === oldReferralId;

          if (!isSameReferrer) {
            const count = await vm.getClientCountForReferral(oldReferralId);
            if (count <= 1) {
              const isNewName =
                typeof vm.selectedReferrer === "string" &&
                vm.selectedReferrer.trim();

              if (isNewName) {
                const parts = vm.selectedReferrer.trim().split(/\s+/);
                const first_name = parts[0] || "";
                const last_name = parts.slice(1).join(" ") || "";
                try {
                  await manageReferral({
                    action: "update",
                    data: { id: oldReferralId, first_name, last_name },
                  });
                  vm.form.referral_id = oldReferralId;
                  const idx = vm.referrers.findIndex((r) => r.value === oldReferralId);
                  if (idx !== -1) {
                    vm.referrers[idx].name = vm.selectedReferrer.trim();
                  }
                  skipReferrerProcessing = true;
                } catch (e) {
                  console.warn("Referral update failed, will create new:", e.message);
                  vm.referrers = vm.referrers.filter((r) => r.value !== oldReferralId);
                }
              } else {
                try {
                  await manageReferral({
                    action: "delete",
                    data: { id: oldReferralId },
                  });
                } catch (e) {
                  console.warn("Referral delete failed:", e.message);
                }
                vm.referrers = vm.referrers.filter((r) => r.value !== oldReferralId);
              }
            }
          }
        }

        if (!skipReferrerProcessing) {
          if (vm.selectedReferrer) {
            if (
              typeof vm.selectedReferrer === "object" &&
              vm.selectedReferrer.value
            ) {
              vm.form.referral_id = vm.selectedReferrer.value;
            } else if (
              typeof vm.selectedReferrer === "string" &&
              vm.selectedReferrer.trim()
            ) {
              const parts = vm.selectedReferrer.trim().split(/\s+/);
              const first_name = parts[0] || "";
              const last_name = parts.slice(1).join(" ") || "";
              const result = await manageReferral({
                action: "create",
                data: { first_name, last_name, email: "" },
              });
              vm.form.referral_id = result.data.id;
              vm.referrers.push({
                name: vm.selectedReferrer.trim(),
                value: result.data.id,
              });
            }
          } else {
            vm.form.referral_id = "";
          }
        }

        let formDoc = {
          ...vm.form,
          email,
          terms: toTerms(terms),
          updated_at: getDate(),
          affiliate_name: vm.getAffiliateName(vm.form.affiliate_id),
          updated_by: vm.userEmail,
        };
        ["first_name", "last_name", "middle_name", "street", "city"].forEach(
          (i) => {
            formDoc[i] = capitalizeText(formDoc[i]);
          }
        );
        if (this.isAffiliateAuth) {
          [
            "customer_type",
            "affiliate_id",
            "no_email",
            "affiliate_id_2",
            "affiliate_id_3",
            "client_type",
            "referred_by",
            "updated_by",
            "affiliate_name",
          ].forEach((k) => delete formDoc[k]);
          const manageClient = httpsCallable(functions, "manageClient");
          await manageClient({ ...formDoc, id: clientId });
          if (clientId) {
            vm.notifySuccess("Client updated successfully.");
          } else {
            vm.notifySuccess("Client added successfully.");
          }
        } else {
          let q = query(colClients, where("email", "==", email), limit(1));
          let snap = (await getDocs(q)).docs;
          if (snap.length !== 0 && clientId !== snap[0].id) {
            vm.loading = false;
            vm.notifyError(
              "Another client exists with the same Email. Please enter a unique Email."
            );
            return;
          }
          if (vm.isUpdate) {
            let ref = doc(colClients, clientId);
            await updateDoc(ref, formDoc);
            vm.notifySuccess("Client updated successfully.");
          } else {
            await addDoc(colClients, { ...formDoc, created_at: getDate() });
            vm.notifySuccess("Client added successfully.");
          }
        }

        vm.loading = false;
        vm.back();
      } catch (error) {
        vm.handleError(error);
      }
    },
    async fetchReferrers() {
      try {
        const referrersSnap = await getDocs(colReferrals);
        this.referrers = referrersSnap.docs.map((doc) => {
          const data = doc.data();
          return {
            name: `${data.first_name} ${data.last_name}`,
            value: doc.id,
          };
        });
      } catch (error) {
        this.handleError(error);
      }
    },
  },
  mounted() {
    this.init();
    this.fetchReferrers();
  },
};
</script>

<style></style>
